<template>
    <div class="project-container">

        <div class="row">
            <div class="left">
                <el-button type="primary" @click="importData" class="createBtn">导 入</el-button>
                <el-select class="w120" v-model="searchDateType" placeholder="请选择">
                    <el-option label="创建时间" value="createTime"></el-option>
                    <el-option label="交易时间" value="tradingTime"></el-option>
                </el-select>
                <el-date-picker v-model="startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-model="endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="right">
                <div class="select-item1">
                    <div class="label">账户类型</div>
                    <el-select v-model="searchAccountType" placeholder="请选择" clearable filterable>
                        <el-option label="银行卡" value="银行卡"></el-option>
                        <el-option label="信用卡" value="信用卡"></el-option>
                        <el-option label="pingpong" value="pingpong"></el-option>
                        <el-option label="GEP" value="GEP"></el-option>
                        <el-option label="万里汇" value="万里汇"></el-option>
                        <el-option label="空中云汇" value="空中云汇"></el-option>
                        <el-option label="连连支付" value="连连支付"></el-option>
                        <el-option label="支付宝" value="支付宝"></el-option>
                        <el-option label="微信" value="微信"></el-option>
                        <el-option label="诚e付" value="诚e付"></el-option>
                    </el-select>
                </div>
                <el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select" clearable>
                    <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                        <el-option label="账户名称" value="accountName"></el-option>
                        <el-option label="账号/卡号" value="account"></el-option>
                    </el-select>
                </el-input>
                <el-select v-model="searchBatch" slot="prepend" placeholder="请选择批次号" clearable class="select-batch"
                    filterable>
                    <el-option v-for="item in batchList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
                <el-button icon="el-icon-search" type="primary" @click="getData">搜 索</el-button>
                <el-button type="primary" @click="initData">重 置</el-button>
                <el-button icon="el-icon-delete" type="danger" @click="delBatchData">删除所选批次</el-button>
                <div class="tools-box">
                    <el-tooltip class="item" effect="dark" content="查看汇总数据" placement="top">
                        <el-button icon="el-icon-s-data" type="text"></el-button>
                    </el-tooltip>

                    <el-popover v-model="showPopover" placement="bottom" width="500" trigger="click" ref="popover">
                        <div class="menu-box">
                            <div class="title">
                                <span>选择列</span>
                                <el-button type="text" @click="handleCheckAllChange">{{ checkAll ? '取消全选' : '全选'
                                    }}</el-button>
                            </div>
                            <el-divider></el-divider>
                            <el-checkbox-group v-model="checkedColumns" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="column in tableColumns" :label="column.prop" :value="column.prop"
                                    :key="column.prop">
                                    {{ column.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <el-divider></el-divider>
                            <div class="footer-box">
                                <div></div>
                                <div>
                                    <el-button @click="showPopover = false">取消</el-button>
                                    <el-button plain type="primary" @click="confirmTableColumn">确定</el-button>
                                </div>
                            </div>
                        </div>
                        <div slot="reference">
                            <el-tooltip content="设置列" placement="top" effect="dark">
                                <el-button icon="el-icon-s-tools" type="text" />
                            </el-tooltip>
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>
        <el-table :data="tableData" border style="width: 100%" max-height="700px" :header-cell-style="getTableHeader()"
            stripe v-loading="loadData">
            <el-table-column v-for="item in tableHeader" :prop="item.prop" :label="item.label" :key="item.key"
                align="center" :width="item.width">
            </el-table-column>
        </el-table>
        <div class="page-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="上传数据" :visible.sync="updFileDialog" width="50%" :before-close="handleUpdFileClose">
            <div>
                <el-upload class="upload-demo" ref="uploadFile" action="" :on-change="handleExcelChange"
                    :auto-upload="false" :limit="1">
                    <div slot="trigger">
                        <el-button type="primary">选取文件</el-button>
                        <el-button @click="downloadTemplate">下载模板</el-button>
                    </div>
                </el-upload>
                <div class="errorList" v-if="errorList.length > 0">
                    <div class="title">错误的交易id：</div>
                    <div class="errorListContent">
                        <p :key="index" v-for="(row, index) in errorList">{{ row }}</p>
                    </div>
                </div>
            </div>
            <div slot="footer" v-loading="updExcelState">
                <span class="dialog-footer">
                    <el-button @click="handleUpdFileClose">取 消</el-button>
                    <el-button type="primary" @click="updExcel">上 传</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getTableHeader, formatDate } from '@/assets/js/common.js'
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
import { mapState } from 'vuex';
import ElInputTrim from '@/components/ElInputTrim/index.vue';
import XLSX from 'xlsx';
// 所有的列
const tableColumns = [
    { prop: 'transactionId', label: '交易id', align: 'center', width: 150 },
    { prop: 'amount', label: '交易金额', align: 'center', width: 100 },
    { prop: 'transactionParty', label: '交易方', align: 'center', width: 130 },
    { prop: 'tradingAccount', label: '交易账号', align: 'center', width: 130 },
    { prop: 'currency', label: '币种', align: 'center', width: 60 },
    { prop: 'incomeExpenditure', label: '收入/支出', align: 'center', width: 80 },
    { prop: 'description', label: '描述', align: 'center' },
    { prop: 'tradingTime', label: '交易时间', align: 'center', width: 100 },
    { prop: 'accountType', label: '账户类型', align: 'center', width: 120 },
    { prop: 'accountNature', label: '账户性质', align: 'center', width: 100 },
    { prop: 'accountName', label: '账户名称', align: 'center', width: 100},
    { prop: 'account', label: '账号/卡号', align: 'center', width: 130 },
    { prop: 'createTime', label: '创建时间', align: 'center', width: 100 },
];
export default {
    name: 'IncomeExpenditureDetails',
    components: {
        ElInputTrim
    },
    props: {},
    data() {
        return {
            searchDateType: 'createTime',
            showPopover: false,
            checkAll: true,
            checkedColumns: tableColumns.map(item => item.prop),
            tableColumns,
            startDate: '',
            endDate: '',
            searchStr: '',
            searchAccountType: '',
            searchType: 'accountName',
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            tableHeaderMap:{},
            tableHeader: [],
            loadData: false,
            batchList: [],
            searchBatch: '',
            updFileDialog: false,
            errorList: [],
            updFileData: [],
            updExcelState: false,
        };
    },
    watch: {},
    computed: {
        ...mapState({
            role: state => state.user.role,
        })
    },

    created() {
        for(let i = 0; i < tableColumns.length; i++){
            const item = tableColumns[i];
            this.tableHeaderMap[item.prop] = item;
        }
        this.endDate = formatDate(Date.now(), 'YYYY-MM-DD');
        this.startDate = this.endDate.substring(0, 7) + '-01';
        if (Object.keys(this.$route.params).length > 0){
            this.startDate = this.$route.params.startDate;
            this.endDate = this.$route.params.endDate;
            this.searchDateType = this.$route.params.searchDateType;
        }
        const localHeader = localStorage.getItem('incomeExpenditureDetailsTableHeader');
        this.checkedColumns = localHeader ? JSON.parse(localHeader) : tableColumns.map(item => item.prop);
        this.tableHeader = tableColumns.filter(item => this.checkedColumns.includes(item.prop));
        this.getBatchList();
    },
    mounted() {
        this.getData();
    },
    methods: {
        downloadTemplate(){
            const aEle = document.createElement('a')
            aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%A4%9A%E8%B4%A6%E6%88%B7%E6%94%B6%E6%94%AF%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF.xlsx'
            aEle.click()
            this.$message.success('正在下载...')
        },
        updExcel() {
            if (this.updFileData.length === 0) {
                this.$message.error('请先上传文件或等待文件解析完成');
                return
            }
            this.updExcelState = true;
            let result = [];
            let api = '';
            result = this.updFileData.map(item => {
                return {
                    ...item,
                    accountId: null,
                }
            })
            api = 'incomeExpenditureDetailsController/importIncomeExpenditureDetails';
            ajaxPost(Baseurl + api, result).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        if (res.data.errorList && res.data.errorList.length > 0) {
                            this.errorList = res.data.errorList;
                        } else {
                            this.handleUpdFileClose();
                            this.$message.success('上传成功！');
                            this.updFileDialog = false;
                            this.updFileData = [];
                            this.getData();
                            this.getBatchList();
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                    this.updExcelState = false;
                }
                this.loadData = false;
            })
        },
        // 格式化日期
        formatRowDate(rawDate) {
            if (typeof rawDate === 'number') {
                const baseDate = new Date(1899, 11, 30); // JavaScript的月份是0-11，所以11代表12月
                // 计算总毫秒数：天数 * 24小时 * 60分钟 * 60秒 * 1000毫秒
                const milliseconds = rawDate * 24 * 60 * 60 * 1000;
                // 创建新日期对象
                const date = new Date(baseDate.getTime() + milliseconds);
                return this.formatDateToString(date);
            } else if (typeof rawDate === 'string') {
                // 兼容多种格式：2025.6.17、2025/06/07 等
                const normalized = rawDate.replace(/\./g, '-').replace(/\//g, '-');
                const date = new Date(normalized);
                return isNaN(date.getTime()) ? rawDate : this.formatDateToString(date);
            } else {
                return rawDate;
            }
        },
        formatDateToString(date) {
            const pad = (n) => String(n).padStart(2, '0');
            const Y = date.getFullYear();
            const M = pad(date.getMonth() + 1);
            const D = pad(date.getDate());
            const h = pad(date.getHours());
            const m = pad(date.getMinutes());
            const s = pad(date.getSeconds());
            return `${Y}-${M}-${D} ${h}:${m}:${s}`;
        },
        handleExcelChange(file) {
            this.updFileData = [];
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                const sheetName = workbook.SheetNames[0]; // 默认读取第一个sheet
                const worksheet = workbook.Sheets[sheetName];
                const header = [
                    { label: '交易id', prop: 'transactionId', required: true, },
                    { label: '币种', prop: 'currency', required: true, },
                    { label: '交易方', prop: 'transactionParty', },
                    { label: '交易账号', prop: 'tradingAccount', },
                    { label: '账号', prop: 'account', required: true, },
                    { label: '账号类型', prop: 'accountType', required: true, },
                    { label: '收入', prop: 'income', },
                    { label: '支出', prop: 'expenditure', },
                    { label: '描述', prop: 'description' },
                    { label: '交易时间', prop: 'tradingTime', required: true, },
                ]
                // const currencyCodes = [
                //     "GBP",  // 英镑
                //     "EUR",  // 欧元
                //     "USD",  // 美元
                //     "CAD",  // 加元
                //     "MXN",  // 墨西哥比索
                //     "JPY",  // 日元
                //     "AUD",  // 澳元
                //     "AED",  // 阿联酋迪拉姆
                //     "SGD",  // 新加坡元
                //     "INR",  // 印度卢比
                //     "SEK",  // 瑞典克朗
                //     "PLN",  // 波兰兹罗提
                //     "SAR",  // 沙特里亚尔
                //     "BRL",  // 巴西雷亚尔
                //     "HKD",   // 港元
                //     "CNH"   // 离岸人民币
                // ];
                const currencyCodes = [
                    "GBP", "EUR", "USD", "CAD", "MXN", "JPY", "AUD", "AED", "SGD",
                    "INR", "CNY", "SEK", "PLN", "SAR", "BRL", "KRW", "RUB", "PHP",
                    "MYR", "TWD", "IDR", "THB", "VND", "COP", "CLP", "ARS", "HUF",
                    "CZK", "TRY", "BGN", "DKK", "NOK", "EGP", "NZD", "HKD", "CNH"
                ];

                // 读取成 JSON，defval: '' 保证空单元格不为 undefined
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                const result = [];
                const errorMessages = [];
                for (let index = 0; index < jsonData.length; index++) {
                    const item = jsonData[index];
                    // 假设日期在第一列，格式化日期
                    if (item['交易时间']) {
                        item['交易时间'] = this.formatRowDate(item['交易时间']);
                    }
                    // 其他字段可以根据需要进行处理
                    const obj = {};
                    const msg = [];
                    let missingTexts = [];
                    for (let i = 0; i < header.length; i++) {
                        const itemHeader = header[i];
                        if (itemHeader.required && (item[itemHeader.label] === '' || item[itemHeader.label] === null || item[itemHeader.label] === undefined)) {
                            missingTexts.push(itemHeader.label);
                        }
                        obj[itemHeader.prop] = item[itemHeader.label] ? (item[itemHeader.label] + '').trim() : null;
                    }
                    if (missingTexts.length > 0) {
                        msg.push(`请填写${missingTexts.join('、')}`);
                    }
                    // if (obj['income'] && obj['expenditure']) {
                    //     msg.push('收入和支出不能同时存在')
                    // }
                    if (!obj['income'] && !obj['expenditure']) {
                        msg.push('收入和支出必须填写一个')
                    }
                    if (!currencyCodes.includes(obj['currency'])) {
                        msg.push('请输入有效币种')
                    }
                    if (obj['income']) {
                        obj['income'] = +(obj['income'] + '').replace(/[\s,]/g, "");
                    }
                    if (obj['expenditure']) {
                        obj['expenditure'] = +(obj['expenditure'] + '').replace(/[\s,]/g, "");
                    }
                    if (msg.length > 0) {
                        errorMessages.push(`第${index + 1}行：${msg.join('，')}`);
                        continue;
                    }
                    result.push(obj);
                }
                if (errorMessages.length > 0) {
                    this.$notify.error({
                        title: '错误',
                        dangerouslyUseHTMLString: true,
                        message: errorMessages.map(item => `<div>${item}</div>`).join(''),
                    });
                    this.$message.error('根据提示信息修改之后重新上传')
                    this.$refs.uploadFile.clearFiles();
                    return;
                }
                this.updFileData = result;
                // 可在此处触发回调或 emit 事件传递数据
            };
            reader.readAsArrayBuffer(file.raw);
        },
        handleUpdFileClose() {
            this.$refs.uploadFile.clearFiles();
            this.errorList = [];
            this.updFileDialog = false;
            this.updFileData = [];
        },
        importData() {
            this.updFileDialog = true;
        },
        delBatchData(){
            if (!this.searchBatch) {
                this.$message.error('请选择要删除的批次号！');
                return;
            }
            this.$confirm('此操作将删除所选批次的全部数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    batchNumber: this.searchBatch,
                }
                ajaxPost(Baseurl + 'incomeExpenditureDetailsController/deleteIncomeExpenditureDetailsByBatch', params).then((res)=>{
                    if(res.status === 200 && res.data.code === 200){
                        this.$message.success('删除成功！');
                        this.searchBatch = '';
                        this.getBatchList();
                        this.page = 1;
                        this.getData();
                    } else {
                        this.$message.error(res.data.message || '删除失败，请稍后再试！');
                    }
                })
            }).catch(() => {});
        },
        getBatchList(){
            ajaxPost(Baseurl + 'incomeExpenditureDetailsController/getIncomeExpenditureBatchList').then((res)=>{
                if(res.status === 200 && res.data.code === 200){
                    this.batchList = res.data.data.map(item => {
                        return {
                            label: formatDate(+item, 'YYYY-MM-DD HH:mm:ss'),
                            value: item,
                        }
                    })
                }
            })
        },
        confirmTableColumn(){
            this.showPopover = false;
            this.checkAll = this.checkedColumns.length === tableColumns.length;
            const result = [];
            const res1 = this.checkedColumns;
            res1.sort((a, b) => {
                const indexA = tableColumns.findIndex(item => item.prop === a);
                const indexB = tableColumns.findIndex(item => item.prop === b);
                return indexA - indexB;
            });
            for (let i = 0; i < res1.length; i++) {
                const prop = res1[i];
                if (this.tableHeaderMap[prop]) {
                    result.push(this.tableHeaderMap[prop]);
                }
            }
            localStorage.setItem('incomeExpenditureDetailsTableHeader', JSON.stringify(res1));
            this.tableHeader = result;
        },
        handleCheckAllChange(val) {
            this.checkAll = !this.checkAll;
            this.checkedColumns = this.checkAll ? tableColumns.map(item => item.prop) : [];
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.tableColumns.length;
        },
        getData() {
            this.loadData = true;
            const params = {
                "page": this.page,
                "size": this.size,
                // "startTime": this.startDate + " 00:00:00",
                // "endTime": this.endDate + " 23:59:59",
                "timeType": this.searchDateType
            }
            if (this.startDate) {
                params['startTime'] = this.startDate + " 00:00:00"
            }
            if (this.endDate) {
                params['endTime'] = this.endDate + " 23:59:59"
            }
            if (this.searchStr) {
                params['searchType'] = this.searchType;
                params['searchStr'] = this.searchStr;
            }
            if (this.searchAccountType){
                params['accountType'] = this.searchAccountType;
            }
            if (this.searchBatch) {
                params['batchNumber'] = this.searchBatch;
            }
            ajaxPost(Baseurl + 'incomeExpenditureDetailsController/selectIncomeExpenditureDetailsPage', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const data = res.data;
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.$refs.popover && this.$refs.popover.show && this.$refs.popover.show();
                this.loadData = false;
            })
        },
        initData(){
            this.page = 1;
            this.size = 10;
            this.searchDateType = 'createTime';
            this.searchBatch = '';
            this.endDate = formatDate(Date.now(), 'YYYY-MM-DD');
            this.startDate = this.endDate.substring(0, 7) + '-01';
            this.searchStr = '';
            this.searchAccountType = '';
            this.searchType = 'accountName';
            this.getData();
        },
        getTableHeader,
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .left,
    .right {
        display: flex;
        align-items: center;
    }
    .left{
        .el-date-editor{
            width: 150px;
        }
        .el-button{
            margin-right: 10px;
        }
    }

    /deep/ .el-date-editor {
        margin: 0 5px;
    }

    .right {
        .el-button {
            margin-left: 10px;
        }

        .el-select {
            width: 120px;
        }
        .tools-box{
            display: flex;
            align-items: center;
            margin-left: 10px;
            .el-button{
                margin: 0;
                font-size: 20px;
                color: #55585f;
                height: 30px;
                line-height: 30px;
                padding: 0 10px;
                &:hover{
                    background-color: rgba(11, 16, 25, .06);
                }
            }
        }
        .select-batch {
            width: 200px;
        }
    }
}

.editable-container {
    width: 100%;
}

.page-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}
.menu-box{
    .title{
        display: flex;
        align-items: center;
        span{
            font-weight: bold;
        }
        .el-button{
            padding: 0 10px;
        }
    }
    .el-divider{
        margin: 10px 0;
    }
    .footer-box{
        display: flex;
        justify-content: space-between;
    }
}
.el-checkbox-group{
    display: flex;
    flex-wrap: wrap;
    .el-checkbox{
        width: 25%;
        margin: 0;
        margin-bottom: 5px;
    }
}
.w120{
    width: 120px;
}
.input-with-select{
    width: 300px;
}
.select-item1 {
    display: flex;
    align-items: center;

    margin-right: 10px;

    .label {
        margin-right: 5px;
        flex-shrink: 0;
    }

    .el-select {
        width: 200px;
        flex: 1;
    }

}
</style>